import { useQuery } from "react-query";
import { InstructionsFetchOptions } from "../models/types";
import queryClient, { QueryKey } from "../state/QueryStore";
import { getInstruction, getInstructions } from "../services/InstructionsService";

export const useInstructions = (params: InstructionsFetchOptions) => {
  return useQuery([QueryKey.Instructions, params], async () => {
    const { data } = await getInstructions(params);
    return data;
  });
};

export const useInstruction = (id: string) => {
  return useQuery([QueryKey.Instructions, id], async () => {
    if (id === "") return null;
    const { data } = await getInstruction(id);
    return data;
  });
};

export const fetchInstructions = (params: InstructionsFetchOptions) => {
  return queryClient.fetchQuery([QueryKey.Instructions, params], async () => {
    const { data } = await getInstructions(params);
    return data;
  });
};

export const searchInstructions = async (searchText: string) => {
  const data = await fetchInstructions({ search: searchText });
  return data.results;
};
